import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import GoogleAnalytics from './components/GoogleAnalytics';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import PostItem from './pages/PostItem';
import ItemDetail from './pages/ItemDetail';
import MyItems from './pages/MyItems';
import MyRequests from './pages/MyRequests';
import MySentRequests from './pages/MySentRequests';
import Chat from './pages/Chat';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <GoogleAnalytics />
        <div className="App">
          <Navbar />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/post-item" element={<PostItem />} />
              <Route path="/item/:id" element={<ItemDetail />} />
              <Route path="/my-items" element={<MyItems />} />
              <Route path="/my-requests" element={<MyRequests />} />
              <Route path="/my-sent-requests" element={<MySentRequests />} />
              <Route path="/chat" element={<Chat />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;

